var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppleBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4146 24.5211C10.4969 24.5043 8.0835 18.5483 8.0835 15.5151C8.0835 10.5604 11.8004 9.47564 13.2329 9.47564C13.8784 9.47564 14.5677 9.72915 15.1757 9.95348C15.6009 10.11 16.0406 10.2715 16.2852 10.2715C16.4315 10.2715 16.7765 10.1341 17.081 10.0135C17.7305 9.75495 18.5387 9.43359 19.4799 9.43359C19.4816 9.43359 19.4838 9.43359 19.4855 9.43359C20.1882 9.43359 22.319 9.58782 23.6 11.5116L23.9001 11.9625L23.4683 12.2884C22.8513 12.7539 21.7256 13.6031 21.7256 15.2852C21.7256 17.2774 23.0005 18.0436 23.613 18.4121C23.8833 18.5747 24.1632 18.7424 24.1632 19.1092C24.1632 19.3487 22.2517 24.4914 19.4759 24.4914C18.7967 24.4914 18.3166 24.2872 17.8931 24.1072C17.4647 23.9249 17.095 23.7679 16.4842 23.7679C16.1746 23.7679 15.7831 23.9142 15.3686 24.0696C14.8022 24.281 14.1611 24.5211 13.4337 24.5211H13.4146Z",
    fill: "#0082FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7738 4.91699C19.8461 7.52356 17.982 9.33187 16.1201 9.21846C15.8132 7.13833 17.9818 4.91699 19.7738 4.91699Z",
    fill: "#0082FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleBlue);
export default __webpack_public_path__ + "static/media/apple-blue.857e10607852b660d03519e917604d3c.svg";
export { ForwardRef as ReactComponent };